module.exports = __webpack_public_path__ + "static/Owlbear-7c1261ebfecdc284ce889d3c923332db.jpg";